import { styled } from 'styled-components';
import { StyledAlertDialogContent } from '@/features/auth-managment/styles';
import { Image } from '@/shared/ui/image';
import { Button } from '@/shared/ui/form/button';

const WrapperBonuse = styled.div`
  max-width: 362px;
  padding: 12px;
  border-radius: 8px;

  background: linear-gradient(180deg, #340d78 0%, #75315e 100%);

  background-image: url('/images/dev/banner.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const WrapperCardBonuse = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  // max-height: 125px;
`;

export { WrapperBonuse, WrapperCardBonuse };
